export default __webpack_public_path__ + "static/media/256.4b2db0c1.jpg";